// for general Cards:
export const QUANTITIES = [20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320, 330, 340, 350, 360, 370, 380, 390, 400];
export const QUANTITY_OPTIONS = QUANTITIES.map(quantity => ({ label: quantity.toString(), value: quantity }));
export const DEFAULT_PAPER_TYPE_VALUE = 'smooth'; // use smooth as default to prevent bug with foil cards that dont have eggshell paper-type as an option
export const DEFAULT_SHAPE_VALUE = 'square';

// export const ALL_PAPER_TYPES_BY_KEY = {
//   smooth: 'Smooth',
//   eggshell: 'Eggshell',
//   recycled: 'Recycled',
//   pearlized: 'Pearlescent',
//   linen: 'Linen',
//   felt: 'Natural',
//   'double-thick': 'Double Thick',
//   'triple-thick': 'Triple Thick',
// };
export const ALL_PAPER_TYPES_BY_KEY = [
  {
    key: 'smooth',
    label: 'smooth',
  },
  {
    key: 'eggshell',
    label: 'eggshell',
  },
  {
    key: 'recycled',
    label: 'recycled',
  },
  {
    key: 'pearlized',
    label: 'pearlescent',
  },
  {
    key: 'linen',
    label: 'linen',
  },
  {
    key: 'felt',
    label: 'natural',
  },
  {
    key: 'double-thick',
    label: 'double thick',
  },
  {
    key: 'triple-thick',
    label: 'triple thick',
  },
];

export const ALL_FILTER_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN',
  'GREY',
  'ORANGE',
  'PINK',
  'PURPLE',
  'RED',
  'WHITE',
  'YELLOW'
];

// for Customization:
export const ORDERED_CUSTOMIZATION_TYPES = [
  'INVITATION',
  'SAVE_THE_DATE',
  'CHANGE_THE_DATE',
  'DETAILS',
  'MENU',
  'PROGRAM',
  'THANK_YOU',
  'RSVP',
  'RSVP_ENVELOPE',
  'INVITATION_ENVELOPE',
  'ENVELOPE',
  'HOLIDAY',
];

export const PRIMARY_CUSTOMIZATION_TYPES = [
  'INVITATION',
  'SAVE_THE_DATE',
  'CHANGE_THE_DATE',
  'DETAILS',
  'MENU',
  'PROGRAM',
  'THANK_YOU',
  'HOLIDAY',
];

export const CUSTOMIZATION_BAR_DROPDOWN_SECTIONS = [
  {
    label: 'FRONT',
    description: 'Print on the front (required)',
    step: 'detailFront'
  },
  {
    label: 'INSIDE',
    description: 'Print on the inside',
    step: 'detailInside'
  },
  {
    label: 'BACK',
    description: 'Print on the back',
    step: 'detailBack'
  },
  {
    label: 'GUESTS',
    description: 'Add guest addressing',
    step: 'recipients'
  },
  {
    label: 'ENVELOPE',
    description: 'Print your return address',
    step: 'envelope'
  },
  {
    label: 'RSVP CARD',
    description: 'Add RSVP cards & envelopes',
    step: 'rsvp'
  },
  {
    label: 'RSVP ENVELOPE',
    description: 'Print mailing address',
    step: 'rsvpEnvelope'
  }
];

export const INVITES_PRODUCT_TYPES = ['INVITATION', 'RSVP', 'SAVE_THE_DATE', 'CHANGE_THE_DATE', 'THANK_YOU', 'HOLIDAY'];
export const TEXT_ALIGNMENT_OPTIONS = ['LEFT', 'CENTER', 'RIGHT'];
export const BACK_PRINTING_PRICE = 35;

// these are the option values that must be present in the variation.option_values
// object of a customization for it to get updated by the customization bar
export const REQUIRED_OPTION_VALUE_KEYS = ['silhouette', 'paper-type'];

export const CARD_TYPE = {
  INVITATION: {
    type: 'INVITATION',
    urlSlug: 'invitations',
    label: 'Invitations',
    hasFoil: true,
    hasMotifs: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  SAVE_THE_DATE: {
    type: 'SAVE_THE_DATE',
    urlSlug: 'save-the-date',
    label: 'Save The Dates',
    hasFoil: true,
    hasMotifs: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  CHANGE_THE_DATE: {
    type: 'CHANGE_THE_DATE',
    urlSlug: 'change-the-date',
    label: 'Change The Dates',
    hasFoil: false,
    hasMotifs: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: false,
    isLead: true,
    showPdpFreeAddressingModule: false,
    showPdpCtdBanner: false,
    showPdpCovidBanner: true,
    showReviewStepCtdBanner: false,
  },
  THANK_YOU: {
    type: 'THANK_YOU',
    urlSlug: 'thank-you-cards',
    label: 'Thank You Cards',
    hasFoil: true,
    hasMotifs: true,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    isLead: true,
    showPdpFreeAddressingModule: true,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  MENU: {
    type: 'MENU',
    urlSlug: 'menus',
    label: 'Menus',
    hasFoil: true,
    hasMotifs: true,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    isLead: true,
    showPdpFreeAddressingModule: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  PROGRAM: {
    type: 'PROGRAM',
    urlSlug: 'programs',
    label: 'Programs',
    hasFoil: true,
    hasMotifs: true,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    isLead: true,
    showPdpFreeAddressingModule: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  DETAILS: {
    type: 'DETAILS',
    urlSlug: 'enclosures',
    label: 'Enclosures',
    hasFoil: true,
    hasMotifs: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    isLead: true,
    showPdpFreeAddressingModule: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  RSVP: {
    type: 'RSVP',
    urlSlug: null, // secondary card type, no slug.
    label: 'RSVP',
    hasFoil: true,
    hasMotifs: null,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: null,
    isLead: false,
    showPdpFreeAddressingModule: null,
    showPdpCtdBanner: null,
    showPdpCovidBanner: null,
    showReviewStepCtdBanner: null,
  },
  ENVELOPE: {
    type: 'ENVELOPE',
    urlSlug: null, // secondary card type, no slug.
    label: 'Envelope',
    hasFoil: null, // Not used for now
    hasMotifs: null,
    hasMultipleOrientations: null,
    hasThirdPartyDesigns: null,
    isLead: false,
    showPdpFreeAddressingModule: null,
    showPdpCtdBanner: null,
    showPdpCovidBanner: null,
    showReviewStepCtdBanner: null,
  },
  HOLIDAY: {
    type: 'HOLIDAY',
    urlSlug: 'holiday-cards',
    label: 'Holiday Cards',
    hasFoil: false,
    hasMotifs: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    isLead: true,
    showPdpFreeAddressingModule: true,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  }
};

export const SIZE_OPTIONS_COPY = {
  magnet: '4.25 x 5.5 in.',
  petite: '4.25 x 5.5 in.',
  postcard: '4.25 x 5.5 in. (does not include envelope)',
  '5x7': '5.0 x 7.0 in.',
  'folded-petite': '4.25 x 5.5 in.'
};

export const ENABLED_SAMPLE_ORDER_CARD_TYPES = ['INVITATION', 'SAVE_THE_DATE'];
export const ENABLED_SAMPLE_ORDER_ALL_CARD_TYPES = ['INVITATION', 'SAVE_THE_DATE', 'CHANGE_THE_DATE', 'MENU', 'PROGRAM', 'DETAILS'];

export const PAGES = ['FRONT', 'INSIDE', 'BACK', 'RSVP', 'RSVP ENVELOPE', 'ENVELOPE'];
export const PAGE_URLS = {
  FRONT: 'detailFront',
  INSIDE: 'detailInside',
  BACK: 'detailBack',
  RSVP: 'rsvp',
  'RSVP ENVELOPE': 'rsvpEnvelope',
  ENVELOPE: 'envelope'
};

export const PROJECT_COPY_MAP = {
  INVITATION: {
    title: 'Wedding Invitation'
  },
  SAVE_THE_DATE: {
    title: 'Save The Date'
  },
  CHANGE_THE_DATE: {
    title: 'Change The Date'
  },
  THANK_YOU: {
    title: 'Thank You Card'
  },
  MENU: {
    title: 'Menu'
  },
  DETAILS: {
    title: 'Enclosure Card'
  },
  PROGRAM: {
    title: 'Program Card'
  },
  HOLIDAY: {
    title: 'Holiday Card'
  }
};

// for PLP:
export const ALL_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN',
  'GREY',
  'ORANGE',
  'PINK',
  'PURPLE',
  'RED',
  'WHITE',
  'YELLOW',
  'BEIGE'
];

export const PLP_MODULE_GROUP_TAGS = {
  DETAILS: 'invites-plp-enclosure',
  ENCLOSURE: 'invites-plp-enclosure',
  DRAPER_JAMES: 'invites-plp-draperjames',
  HOLIDAY: 'invites-plp-holiday',
  INVITATION: 'invites-plp-invitation',
  LOVELY_BRIDE: 'invites-plp-lovelybride',
  MENU: 'invites-plp-menu',
  PLACE_CARDS: 'invites-plp-placecard',
  PROGRAM: 'invites-plp-program',
  SAVE_THE_DATE: 'invites-plp-savethedate',
  CHANGE_THE_DATE: 'invites-plp-changethedate',
  THANK_YOU: 'invites-plp-thankyou',
};

export const PDP_MODULE_GROUP_TAGS = {
  DETAILS: 'invites-pdp-enclosure',
  ENCLOSURE: 'invites-pdp-enclosure',
  HOLIDAY: 'invites-pdp-holiday',
  INVITATION: 'invites-pdp-invitation',
  MENU: 'invites-pdp-menu',
  PLACE_CARDS: 'invites-pdp-placecard',
  PROGRAM: 'invites-pdp-program',
  SAVE_THE_DATE: 'invites-pdp-savethedate',
  CHANGE_THE_DATE: 'invites-pdp-changethedate',
  THANK_YOU: 'invites-pdp-thankyou',
};

export const PROMO_BADGE_EXCLUSIONS = ['DRAPER_JAMES', 'LOVELY_BRIDE'];

export const HERO_COPY = {
  INVITATION: {
    header: 'Wedding Invitations',
    description: 'Invite guests with the perfect stationery that matches your wedding style.'
  },
  SAVE_THE_DATE: {
    header: 'Save The Dates',
    subheader: '',
    description:
      'Set the tone for your wedding and choose a beautiful design that shows off your style.'
  },
  CHANGE_THE_DATE: {
    header: 'Change The Dates',
    subheader: '',
    description:
      'Set the tone for your wedding and choose a beautiful design that shows off your style.'
  },
  DETAILS: {
    header: 'Enclosure Cards',
    subheader: '',
    description: 'Complete your invitation suite and share all your wedding details with guests.'
  },
  MENU: {
    header: 'Wedding Menus',
    subheader: '',
    description:
      'Show guests your meal options on gorgeous cards that match your suite.'
  },
  PROGRAM: {
    header: 'Wedding Programs',
    subheader: '',
    description: 'Choose a design to highlight your unique ceremony details, fun facts, and more.'
  },
  THANK_YOU: {
    header: 'Thank You Cards',
    subheader: '',
    description:
      'Write your thoughtful notes on a special design. You can even add a custom wedding photo.'
  },
  DRAPER_JAMES: {
    header: 'Zola x Draper James',
    subheader: '',
    description:
      ' Inspired by Reese Witherspoon’s Southern roots, Draper James <em>always</em> brings the style (no matter your location on the map).'
  },
  LOVELY_BRIDE: {
    header: 'Zola x Lovely Bride',
    subheader: '',
    description:
      'This exclusive paper collab feels just like walking into a Lovely Bride shop: low key, chic, and designed for real-life couples.'
  },
  HOLIDAY: {
    header: 'Holiday Cards',
    subheader: '',
    description:
      'Send your season’s greetings with a unique design your friends and family will love.'
  },
  PLACE_CARDS: {
    header: ' Place Cards',
    subheader: '',
    description:
      'Help your guests find their reception table with these elegant designs.'
  },
};

export const ROUTES_PLP_LEAD_CARD = {
  invitations: {
    leadCardType: 'INVITATION'
  },
  'save-the-date': {
    leadCardType: 'SAVE_THE_DATE'
  },
  'change-the-date': {
    leadCardType: 'CHANGE_THE_DATE'
  },
  'thank-you-cards': {
    leadCardType: 'THANK_YOU'
  },
  menus: {
    leadCardType: 'MENU'
  },
  enclosures: {
    leadCardType: 'DETAILS'
  },
  programs: {
    leadCardType: 'PROGRAM'
  },
  'place-cards': {
    leadCardType: 'PLACE_CARDS'
  },
  'draper-james': {
    leadCardType: null,
    collaborator: 'DRAPER_JAMES'
  },
  'lovely-bride': {
    leadCardType: null,
    collaborator: 'LOVELY_BRIDE'
  },
  'holiday-cards': {
    leadCardType: 'HOLIDAY'
  }
};

export const PLP_EVENTS_AND_TITLES = {
  invitations: {
    activeCardEvent: 'INVITATION',
    pageTitle: 'Affordable Wedding Invitations | Hundreds of Templates & Samples',
    metaDescription: 'Discover wedding invitations that will leave your guests breathless. Explore beautiful designs & choose an invite that sets the perfect tone for your big day.',
    metaKeywords: 'Wedding invites,Wedding invitations,wedding invitation templates,Wedding invitation cards,Sample wedding invitations,Wedding invitation design,Wedding envelopes',
    canonical: `https://${window.location.hostname}/wedding-planning/invitations/shop`,
  },
  'thank-you-cards': {
    activeCardEvent: 'THANK_YOU',
    pageTitle: 'Thank You Cards to Match Your Save The Dates, Invitations, and Wedding Website',
    metaDescription: 'Find wedding thank you cards that will charm & delight your guests. Choose from dozens of beautiful designs to match your wedding theme and order in minutes.',
    metaKeywords: 'Wedding thank you cards,Custom thank you cards,Wedding thank you',
    canonical: `https://${window.location.hostname}/wedding-planning/thank-you-cards/shop`,
  },
  menus: {
    activeCardEvent: 'MENU',
    pageTitle: 'Affordable Menus for your Wedding Reception | Hundreds of Templates & Samples',
    metaDescription: 'Create a beautiful dining experience with the perfect wedding menu. Choose from dozens of elegant and charming designs and styles to match any wedding theme.',
    metaKeywords: 'Wedding menu,wedding menu cards,menu cards,wedding reception food menu',
    canonical: `https://${window.location.hostname}/wedding-planning/menus/shop`,
  },
  programs: {
    activeCardEvent: 'PROGRAM',
    pageTitle: 'Affordable Wedding Programs | Hundreds of Templates & Samples',
    metaDescription: 'Get the perfect program for your wedding day. Choose from dozens of charming designs to match your wedding theme and style & order with a few clicks.',
    metaKeywords: 'Wedding programs,Wedding programs template,Ceremony program,Ceremony program template',
    canonical: `https://${window.location.hostname}/wedding-planning/programs/shop`,
  },
  enclosures: {
    activeCardEvent: 'DETAILS',
    pageTitle: 'Affordable Enclosure Cards | Hundreds of Templates & Samples',
    metaDescription: 'Get beautiful & elegant enclosure cards for your wedding. Choose from dozens of alluring designs that match your wedding theme & order with a few clicks.',
    canonical: `https://${window.location.hostname}/wedding-planning/enclosures/shop`,
  },
  'draper-james': {
    activeCardEvent: 'DRAPER_JAMES',
    pageTitle: 'Draper x Zola | a fresh take on Southern charm',
  },
  'lovely-bride': {
    activeCardEvent: 'LOVELY_BRIDE',
    pageTitle: 'Zola x Lovely Bride | Low key, chic invite suites'
  },
  'place-cards': {
    activeCardEvent: 'PLACE_CARDS',
    pageTitle: 'Affordable Place Cards | Hundreds of Templates & Samples'
  },
  'save-the-date': {
    activeCardEvent: 'SAVE_THE_DATE',
    pageTitle: 'Save The Date Cards for Weddings - Free Shipping | Zola',
    metaDescription: 'Find a perfect Save The Date card for your wedding in minutes. Choose from beautiful designs and gorgeous imagery that sets the tone for your special day.',
    metaKeywords: 'save the date,Save the date cards,save the date magnets,Save the date wedding,Save the date invitations',
    canonical: `https://${window.location.hostname}/wedding-planning/save-the-date/shop`,
  },
  'change-the-date': {
    activeCardEvent: 'CHANGE_THE_DATE',
    pageTitle: 'Change The Date Cards for Weddings - Free Shipping | Zola',
    metaDescription: 'Find a Change The Date card to update guests if your wedding plans have changed. Get wording tips, free guest addressing, free back-of-card printing, and more.',
    canonical: `https://${window.location.hostname}/wedding-planning/change-the-date/shop`,
  },
  'holiday-cards': {
    activeCardEvent: 'HOLIDAY',
    pageTitle: 'Affordable Holiday Cards | Unique Templates & Designs',
    canonical: `https://${window.location.hostname}/wedding-planning/holiday-cards/shop`,
  }
};

export const BASE_URL = '/wedding-planning';



// WEBPACK FOOTER //
// ./src/cards/constants/Cards.js